import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const loansHistorySlice = createSlice({
  name: "loansHistory",

  initialState: { loansHistory: [], loanHistoryLoader: false },
  reducers: {
    setAllLoansHistory: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.loansHistory = payload;
    },
    setAllLoansHistoryLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.loanHistoryLoader = payload;
    },
    resetAllLoansHistory: (state) => {
      state.loansHistory = [];
    },
  },
});

export const {
  setAllLoansHistory,
  resetAllLoansHistory,
  setAllLoansHistoryLoader,
} = loansHistorySlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default loansHistorySlice.reducer;
